import { render, staticRenderFns } from "./UButton.vue?vue&type=template&id=01c47640&scoped=true&"
import script from "./UButton.vue?vue&type=script&lang=js&"
export * from "./UButton.vue?vue&type=script&lang=js&"
import style0 from "./UButton.vue?vue&type=style&index=0&id=01c47640&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c47640",
  null
  
)

export default component.exports